<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex flex-col gap-6 bg-gray-50 p-6">
    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Ustawienia KSeF</h5>

      <div class="grid gap-6 lg:grid-cols-2">
        <app-details-view label="Połączenie z KSeF">
          <div
            [ngClass]="{
            'bg-green-50 text-green-700': isConnectedWithKsef,
            'bg-red-50 text-red-700': !isConnectedWithKsef,
          }"
            class="inline-flex rounded-full px-3 py-2 text-sm font-semibold">
            {{ isConnectedWithKsef ? 'Tak' : 'Nie' }}
          </div>
        </app-details-view>

        <app-form-control label="Automatyczna wysyłka do KSeF">
          <p-toggle-switch [formControl]="form.controls.sendToKsef" />
        </app-form-control>
      </div>
    </section>

    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Proforma</h5>

      <div class="grid gap-6 lg:grid-cols-2">
        <app-form-control label="Nazwa banku dla proformy">
          <input
            [formControl]="form.controls.temporaryInvoiceBankName"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź nazwę banku" />
        </app-form-control>

        <app-form-control label="Numer konta dla proformy">
          <input
            [formControl]="form.controls.temporaryInvoiceAccount"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź numer konta w formacie IBAN" />
        </app-form-control>
      </div>
    </section>

    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Ustawienia faktur</h5>

      <div class="grid gap-6 lg:grid-cols-2">
        <app-form-control label="Osoba wystawiająca faktury">
          <input
            [formControl]="form.controls.seller"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź dane osoby wystawiającej" />
        </app-form-control>
      </div>
    </section>

    <div class="mt-auto flex justify-end">
      <p-button
        appPrimengButton
        label="Zapisz"
        severity="primary"
        type="submit" />
    </div>
  </div>
</form>
